<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {navigate} from "src/components/cabinet/#common/helpers"
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import Editor from '@tinymce/tinymce-svelte'
    import {getCategories, createTask} from 'src/components/cabinet/#services/tasksBot'

    getCategories.send();

    let saved = false
    let descriptionEn = ''
    let descriptionRu = ''
    $: titleEn = ''
    $: titleRu = ''
    $: link = ''
    $: award = ''
    $: deadline = ''
    $: category = 0
    $: availableAttempts = 1

    let conf = {
        apiKey: "575wkjbaqgl2wp1rjkca9tdq4mg9k5b0xkruqqdg25p375c3",
        plugins: 'link code lists advlist quickbars image editimage media mediaembed',
        toolbar: 'undo redo | bold italic underline strikethrough | link | bullist numlist | code',
        menubar: false,
        relative_urls: false,
        remove_script_host: false,
        quickbars_insert_toolbar: false,
        link_assume_external_targets: true
    }

    async function create() {
        saved = true

        if (descriptionEn !== '' && descriptionRu !== '' && award !== '' && deadline !== '' && category !== 0 && availableAttempts > 0) {
            try {
                await createTask.request({data: {
                    titleEn,
                    titleRu,
                    descriptionEn,
                    descriptionRu,
                    availableAttempts,
                    link,
                    award,
                    deadline,
                    categoryId: category
                }})

                showAlert.set({
                    status: 'success',
                    text: 'Task successfully created!'
                })

                setTimeout(function () {
                    navigate("/tasks/all");
                }, 500)
            } catch (e) {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }
</script>

<svelte:head>
    <title>Create task</title>
</svelte:head>

<MainLayout title="Create task">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="tasks/all" class="btn btn-primary mb-3">Back</Link>
                <div class="row mb-3">
                    <div class="col-lg-8">
                        <div class="form-group mb-3">
                            <label>Title En</label>
                            <input type="text" class="form-control" bind:value={titleEn}
                                class:is-invalid={saved && titleEn === ''}>
                        </div>
                        <div class="form-group mb-3">
                            <label>Title Ru</label>
                            <input type="text" class="form-control" bind:value={titleRu}
                                class:is-invalid={saved && titleRu === ''}>
                        </div>
                        <div class="form-group mb-3">
                            <label>Content En</label>
                            <Editor
                                scriptSrc="/js/tinymce.min.js"
                                api-key="575wkjbaqgl2wp1rjkca9tdq4mg9k5b0xkruqqdg25p375c3"
                                bind:value={descriptionEn}
                                {conf}
                            />
                            <span class="help-block text-danger" class:d-block={saved && descriptionEn === ''}
                                style="display: none;">Enter description</span>
                        </div>
                        <div class="form-group mb-3">
                            <label>Content Ru</label>
                            <Editor
                                scriptSrc="/js/tinymce.min.js"
                                api-key="575wkjbaqgl2wp1rjkca9tdq4mg9k5b0xkruqqdg25p375c3"
                                bind:value={descriptionRu}
                                {conf}
                            />
                            <span class="help-block text-danger" class:d-block={saved && descriptionRu === ''}
                                style="display: none;">Enter description</span>
                        </div>
                        <div class="form-group mb-3">
                            <label>Reward</label>
                            <div class="input-group">
                                <input type="number" class="form-control" bind:value={award}
                                    class:is-invalid={saved && award === ''}>
                                <span class="input-group-text">Points</span>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label>Max completions count</label>
                            <input type="number" class="form-control" bind:value={availableAttempts}
                                class:is-invalid={saved && (!availableAttempts || availableAttempts === 0)}>
                        </div>
                        <div class="form-group mb-3">
                            <label>Link</label>
                            <div class="input-group">
                                <span class="input-group-text">URL</span>
                                <input type="text" class="form-control" bind:value={link}>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label>End date</label>
                            <input type="date" class="form-control" bind:value={deadline} class:is-invalid={saved && deadline === ''}>
                        </div>
                        <div class="form-group mb-3">
                            <label>Category</label>
                            {#if !$getCategories.hasValue && $getCategories.loading}
                                <select class="form-select" disabled>
                                    <option selected>Loading...</option>
                                </select>
                            {:else if !$getCategories.hasValue && $getCategories.error }
                                <select class="form-select" disabled>
                                    <option selected>Something went wrong</option>
                                </select>
                            {:else if $getCategories.value}
                                <select class="form-select" bind:value={category}
                                    class:is-invalid={saved && category === 0}>
                                    <option value={0} selected disabled>Select category</option>
                                    {#each $getCategories.value as { id, name }}
                                        <option value={id}>{name}</option>
                                    {/each}
                                </select>
                            {/if}
                        </div>
                    </div>
                </div>
                <button class="btn btn-success" on:click={create}>Create</button>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .input-group-text {
        height: 38px;
        font-size: 14px;
        color: #296bff;
    }
</style>
